import React, { useState, useEffect } from "react";
import {
  Box,
  Checkbox,
  Divider,
  FormControl,
  FormControlLabel,
  FormGroup,
  Icon,
  MenuItem,
  Modal,
  Radio,
  RadioGroup,
  Select,
  Typography,
  Card,
  FormHelperText,
} from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import PropTypes from "prop-types";
import { RoleListService } from "layouts/role/services/RoleService";
import MDTypography from "components/MDTypography";

export function UserCreate({
  open,
  handleClose,
  isDisabled,
  getFieldValue,
  handleFieldChange,
  handleSubmit,
  isFieldValid,
  handleRoleList,
  isFormModified, //Agregado recientemente
}) {
  //Comentado recientemente
  // const [isFormModified, setIsFormModified] = useState(false);

  const [editedData, setEditedData] = useState({
    first_name: "string",
    last_name: "string",
    role_id: "string",
    status: "string",
  });

  const [newData, setNewData] = useState({
    first_name: "string",
    last_name: "string",
    role_id: "string",
    status: "string",
  });

  //const [handleRoleList, setRoleList] = useState([]);

  const requestRoleList = async (pageIndex) => {
    // const result = await RoleListService(pageIndex);
    // if (result && result.payload) {
    //   const { payload } = result;
    //   const roleArray = Object.entries(payload.data);
    //   setRoleList(payload.data);
    // }
  };

  //useEffect(() => {
  // requestRoleList();
  //}, []);

  //Comentado recientemente
  // useEffect(() => {
  //   const hasFormChanged = Object.keys(editedData).some((key) => editedData[key] !== newData[key]);

  //   const isAnyFieldEmpty = Object.values(editedData).some((value) => !value);

  //   setIsFormModified(!isAnyFieldEmpty && hasFormChanged);
  // }, [editedData, newData]);

  //Comentado recientemente
  // useEffect(() => {
  //   const requiredFields = ["name", "lastname", "role_id", "status"];
  //   const someFieldIsEmpty = requiredFields.some((fieldName) => !editedData[fieldName]);
  //   setIsFormModified(someFieldIsEmpty);
  // }, [editedData]);



  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "90%",
    maxWidth: "400px",
    borderRadius: "20px",
    boxShadow: 24,
    p: 4,
  };
  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Card sx={style}>
        <MDBox
          mt={-7}
          color="white"
          bgColor="info"
          variant="gradient"
          borderRadius="lg"
          p={2}
          sx={{ display: "flex", justifyContent: "flex-end" }}
        >
          <Typography id="modal-modal-title" component="h2">
            Crear nuevo usuario
          </Typography>
          <Icon
            sx={{
              fontSize: "2em",
              stroke: "currentColor",
              strokeWidth: "2px",
              cursor: "pointer",
              marginLeft: "auto",
            }}
            onClick={handleClose}
          >
            close
          </Icon>
        </MDBox>
        <Divider variant="middle" />
        <MDTypography
          variant="h5"
          >Nombres</MDTypography>
        <MDInput
          disabled={isDisabled}
          style={{ marginTop: "5px" }}
          value={getFieldValue("first_name")}
          error={!isFieldValid.first_name}
          helperText={
            getFieldValue("first_name") === "" && !isFieldValid.first_name
              ? "El campo no puede estar vacío"
              : !isFieldValid.first_name
              ? "No se permiten números ni caracteres especiales"
              : ""
          }
          FormHelperTextProps={{ className: !isFieldValid.first_name ? "Mui-error" : "" }}
          onChange={(e) => handleFieldChange("first_name", e.target.value)}
        />
        <br />
        <MDTypography
          variant="h5"
          >Apellidos</MDTypography>
        <MDInput
          disabled={isDisabled}
          style={{ marginTop: "5px" }}
          value={getFieldValue("last_name")}
          error={!isFieldValid.last_name}
          helperText={
            getFieldValue("last_name") === "" && !isFieldValid.last_name
              ? "El campo no puede estar vacío"
              : !isFieldValid.last_name
              ? "No se permiten números ni caracteres especiales"
              : ""
          }
          FormHelperTextProps={{ className: !isFieldValid.last_name ? "Mui-error" : "" }}
          onChange={(e) => handleFieldChange("last_name", e.target.value)}
        />
        <br />
        <MDTypography
          variant="h5"
          >Correo electrónico</MDTypography>
        <MDInput
          disabled={isDisabled}
          style={{ marginTop: "5px" }}
          value={getFieldValue("data_types")?.value}
          error={!isFieldValid.data_types}
          helperText={!isFieldValid.data_types ? "Digite un email valido." : ""}
          FormHelperTextProps={{ className: !isFieldValid.data_types ? "Mui-error" : "" }}
          onChange={(e) => handleFieldChange("data_types", e.target.value)}
        />
        <br />
        <form onSubmit={handleSubmit}>
          <Box display="flex" alignItems="flex-start">
            <Box sx={{ marginRight: "20px" }}>
              <MDTypography
                variant="h5"
                sx={{ mt: 2 }}
                >Rol</MDTypography>
              <FormControl sx={{ minWidth: 80 }} error={!isFieldValid.role_id}>
                <Select
                  labelId="demo-simple-select-autowidth-label"
                  id="demo-simple-select-autowidth"
                  value={getFieldValue("role_id")}
                  onChange={(e) => handleFieldChange("role_id", e.target.value)}
                  style={{ fontSize: "15px", padding: "10px" }}
                  disabled={isDisabled}
                  displayEmpty
                >
                  <MenuItem value={""}>Seleccione...</MenuItem>
                  {handleRoleList
                    ? handleRoleList.map((role) => (
                        <MenuItem key={role.id} value={role.id}>
                          {role.name}
                        </MenuItem>
                      ))
                    : []}
                </Select>
                {!isFieldValid.role_id && <FormHelperText>Rol requerido</FormHelperText>}
              </FormControl>
            </Box>
            <Box>
              <MDTypography
                variant="h5"
                sx={{ mt: 2 }}
                >Estado</MDTypography>
              <FormControl error={!isFieldValid.status}>
                <RadioGroup
                  aria-labelledby="demo-controlled-radio-buttons-group"
                  name="controlled-radio-buttons-group"
                  value={getFieldValue("status")}
                  onChange={(e) => handleFieldChange("status", e.target.value)}
                >
                  <FormControlLabel
                    disabled={isDisabled}
                    value={"Activo"}
                    control={<Radio />}
                    label="Activo"
                  />
                  <FormControlLabel
                    disabled={isDisabled}
                    value={"Inactivo"}
                    control={<Radio />}
                    label="Inactivo"
                  />
                </RadioGroup>
                {!isFieldValid.status && <FormHelperText>Rol requerido</FormHelperText>}
              </FormControl>
            </Box>
          </Box>
          <Divider variant="middle" />
          <Box
            style={{
              display: "flex",
              justifyContent: "space-between",
              mt: 2,
            }}
          >
            <MDButton
              onClick={handleClose}
              color="error"
              sx={{
                flex: 1,
                mr: 1,
              }}
            >
              Cancelar
            </MDButton>
            <MDButton
              type="submit"
              color="success"
              disabled={isFormModified}
              sx={{
                flex: 1,
                mr: 1,
              }}
            >
              Crear
            </MDButton>
          </Box>
        </form>
      </Card>
    </Modal>
  );
}

UserCreate.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  isDisabled: PropTypes.bool,
  getFieldValue: PropTypes.func,
  handleFieldChange: PropTypes.func,
  handleSubmit: PropTypes.func,
  isFieldValid: PropTypes.shape({
    first_name: PropTypes.bool,
    last_name: PropTypes.bool,
    email: PropTypes.bool,
    role_id: PropTypes.bool,
    status: PropTypes.bool,
  }),
};
